import { Text } from '@thanx/uikit/text'
import { useStyletron } from 'baseui'
import { merchantTheme } from 'theme'

interface CategoryFilterProps {
  categories: Array<{ id: string | null; name: string }>
  selectedCategoryId: string | null
  onSelectCategory: (categoryId: string | null) => void
}

interface CategoryFilterItemProps {
  category: { id: string | null; name: string }
  selectedCategoryId: string | null
  onSelectCategory: (categoryId: string | null) => void
}

const CategoryFilterItem = ({
  category,
  selectedCategoryId,
  onSelectCategory,
}: CategoryFilterItemProps) => {
  const [css] = useStyletron()

  return (
    <li>
      <button
        onClick={() => onSelectCategory(category.id)}
        data-testid="category-filter-item"
        className={css({
          display: 'grid',
          gridTemplateColumns: '1fr',
          width: '100%',
          background:
            selectedCategoryId === category.id
              ? merchantTheme.colors.belizeHole10
              : 'transparent',
          border: 'none',
          cursor: 'pointer',
          textAlign: 'left',
          ':hover': {
            background: merchantTheme.colors.grey10,
          },
        })}
      >
        <Text.BodyText4
          bold={selectedCategoryId === category.id}
          className="py-s"
        >
          {category.name}
        </Text.BodyText4>
      </button>
    </li>
  )
}

const CategoryFilter = ({
  categories,
  selectedCategoryId,
  onSelectCategory,
}: CategoryFilterProps) => {
  const [css] = useStyletron()

  return (
    <div>
      <ul className={css({ listStyle: 'none', padding: 0, margin: 0 })}>
        {categories.map(category => (
          <CategoryFilterItem
            key={`insights-lab-category-filter-${category.id}`}
            category={category}
            selectedCategoryId={selectedCategoryId}
            onSelectCategory={onSelectCategory}
          />
        ))}
      </ul>
    </div>
  )
}

export default CategoryFilter
